import { render, staticRenderFns } from "./CreditsChangeHistoryModal.vue?vue&type=template&id=ecf7fba4&scoped=true"
import script from "./CreditsChangeHistoryModal.vue?vue&type=script&lang=ts"
export * from "./CreditsChangeHistoryModal.vue?vue&type=script&lang=ts"
import style0 from "./CreditsChangeHistoryModal.vue?vue&type=style&index=0&id=ecf7fba4&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ecf7fba4",
  null
  
)

export default component.exports